import Cookie from 'js-cookie';

import { defaultAuthenticationState } from 'state/defaults';
import { LOGGED_IN_JWT_COOKIE } from 'utils/constants';

import { RMA_MANAGER_USER, RMA_MANAGER_MANAGER, RMA_MANAGER_ALLOW_FEES } from './permissions';
import { END_CUSTOMER, VAR, ACCOUNT_MANAGER } from './userTypes';

export const getJwt = () => Cookie.get(LOGGED_IN_JWT_COOKIE);

export const parseJwt = (token) => {
  let parsedData = {};

  try {
    const base64Jwt = token.split('.')[1].replace('-', '+').replace('_', '/');
    parsedData = JSON.parse(window.atob(base64Jwt));
  } catch (e) {}

  return parsedData;
};

const getAccountName = (accountData, parsedAuthData) => {
  if (parsedAuthData.userType === VAR || parsedAuthData.userType === END_CUSTOMER) {
    return parsedAuthData.Account;
  } else {
    return accountData.accountName || parsedAuthData.Account;
  }
};

// Get auth data from Cookie
export const getAuthData = () => {
  const loggedInUserEcommJWT = getJwt();
  const accountData = JSON.parse(localStorage.getItem('current-account')) || {};

  // If the cookie is missing the user is not isAuthenticated
  // so we will do nothing
  if (!loggedInUserEcommJWT) {
    console.error('Missing Auth Token');
    return defaultAuthenticationState;
  }

  // Get jwt data object
  const parsedAuthData = parseJwt(loggedInUserEcommJWT);
  if (
    !parsedAuthData.Account ||
    !parsedAuthData.userType ||
    !parsedAuthData.AccountSFid ||
    !parsedAuthData.ECommerceAccess
  ) {
    console.error('Auth Token Missing Required Data', parsedAuthData);
    return defaultAuthenticationState;
  }

  const eCommerceAccess = parsedAuthData.ECommerceAccess || [];
  const canAccessRma = [RMA_MANAGER_USER, RMA_MANAGER_MANAGER].some((access) =>
    eCommerceAccess.includes(access)
  );
  const hasAllowFeePermission = [RMA_MANAGER_ALLOW_FEES].some((permission) =>
    eCommerceAccess.includes(permission)
  );

  // Return an object with the auth data
  return {
    isAuthenticated: true,
    account: getAccountName(accountData, parsedAuthData),
    canAccessRma,
    hasAllowFeePermission,
    accountId: parsedAuthData.AccountSFid,
    endCustomerAccountId:
      parsedAuthData.userType === ACCOUNT_MANAGER
        ? accountData.accountId
        : parsedAuthData.AccountSFid,
    varAccountId: parsedAuthData.userType === 'VAR' ? parsedAuthData.AccountSFid : '',
    ecomAccess: parsedAuthData.EcomAccess && parsedAuthData.EcomAccess.toLowerCase() === 'true',
    ecomCheckout:
      parsedAuthData.EcomCheckout && parsedAuthData.EcomCheckout.toLowerCase() === 'true',
    eCommerceAccess,
    userSFid: parsedAuthData.UserSFid,
    fullName: `${parsedAuthData.FirstName} ${parsedAuthData.LastName}`,
    email: parsedAuthData.email,
    contactId: parsedAuthData.ContactId,
    userType: parsedAuthData.userType,
    userName: parsedAuthData.username,
    parsedAuthData,
    jwt: loggedInUserEcommJWT,
  };
};
